import { put, takeEvery, call } from 'redux-saga/effects';
import * as actions from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import transactionServices from '../../../services/transactionServices';

export default function* getHistorySaga() {
  yield takeEvery(actionTypes.BANK_TRANSACTION.GET_HISTORY, getHistory);
}

export function* getHistory(action) {
  try {
    const response = yield call(transactionServices.getHistory, action.payload);
    const { success, data, message } = response;
    if (success) {
      yield put(actions.getHistorySuccess(data));
    } else {
      yield put(actions.getHistoryFail(message));
    }
  } catch (error) {
    yield put(actions.getHistoryFail(error));
  }
}
